import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: ${CSSVars.white};
  padding: 50px 20px 0;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 70px 30px 0;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 90px 40px 0;
  }

  .inner {
    max-width: 920px;
    margin: 0 auto;
    text-align: center;
  }

  p {
    font-family: ${CSSVars.secondaryFont};
    font-weight: 400;
    font-size: 18px;
    line-height: 1.7;
    color: #374151;
    margin: 0;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 20px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 22px;
    }

    strong {
      color: ${CSSVars.black};
      font-weight: 600;
    }
  }

  p + p {
    margin-top: 16px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      margin-top: 20px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      margin-top: 24px;
    }
  }
`;
